import React, { memo, useMemo, useState } from 'react'
import { TAverageWithInactivity, TAverageWithoutInactivity } from '../../shared/types/exam.type'
import { Box, Card, CardContent, LinearProgress, Switch, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import { isEmpty, orderBy, sortBy } from 'lodash'
import dayjs from 'dayjs'
import { Info } from '@mui/icons-material'
import { useAuth } from '../../hooks/useAuth'

var duration = require('dayjs/plugin/duration')
dayjs.extend(duration)


type HrActivityProps = {
    params: {
        includeInactivity?: TAverageWithInactivity[],
        excludeInactivity?: TAverageWithoutInactivity[]
    },
    printable?: boolean
}

const colors = ["#caf0f8", "#90e0ef", "#0077B6", "#013e8b", "#03045e"]


function HrActivityZone({ params, printable = false }: HrActivityProps) {
    const [include, setInclude] = useState(false)

    return (

        <div >


            <NotIncluded data={!include ? params.excludeInactivity : params.includeInactivity}></NotIncluded>
            {
                !printable && <Card elevation={3} sx={{
                    p: 1,
                    mt: 2,
                    borderRadius: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Typography pl={1} variant='subtitle2'>{t('hrZones:includeInactivityAndWalk')}</Typography>
                    <Switch checked={include} onChange={e => setInclude(e.target.checked)}></Switch>
                </Card>
            }
        </div>
    )
}

const getTime = (seconds?: number) => {
    if (!seconds) return "00:00"
    return new Date(seconds * 1000)
        .toISOString()
        .slice(14, 19);
}

const getTitle = (index: number, isUserTypePolo: boolean): { title: string, hint: string } => ({
    title: t((isUserTypePolo ? 'zone:polo:name:' : 'zone:name:').concat(index.toString())),
    hint: t((isUserTypePolo ? 'zone:detail:' : 'zone:detail:').concat(index.toString()))
})

const getBpm = (max?: number, min?: number) => {
    if (max && min) {
        return `${min} - ${max} ${t('units:bpm')}`
    }
    if (max && !min) {
        return `< ${max} ${t('units:bpm')}`
    } else {
        return `> ${min} ${t('units:bpm')}`
    }
}

function NotIncluded({ data }: { data?: TAverageWithoutInactivity[] | TAverageWithInactivity[] }) {

    const { auth, isUserTypePolo } = useAuth()


    const orderedDataWithColor = useMemo(() => {
        let ordered = orderBy(data, 'index', 'desc')
        return ordered.map((item, index) => ({ ...item, color: colors[item.index] }))
    }, [data])


    return <div id='fcZone'>
        {!isEmpty(orderedDataWithColor) ? orderedDataWithColor?.map((item, index) => (
            <Box display={'flex'} flexDirection={'column'} gap={2} mb={1} key={item?.index}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography className="fcZoneSecs" sx={{ flex: 1, order: isUserTypePolo ? -3 : 0 }} variant='caption'
                        fontWeight={500}>{getTime(item?.time_seconds)}</Typography>
                    <Typography sx={{ flex: 2, order: isUserTypePolo ? -5 : 0 }} variant='caption'
                        fontWeight={500}>{getTitle(isUserTypePolo ? index : item.index, isUserTypePolo).title}</Typography>
                    <Tooltip sx={{ flex: 1 }} placement='left'
                        title={getTitle(item.index, isUserTypePolo).hint}
                        arrow>
                        <Info color='info' sx={{ width: 15, height: 15 }}></Info>
                    </Tooltip>
                    <Typography sx={{ textAlign: "center", flex: 2, order: isUserTypePolo ? -4 : 0 }} variant='caption'
                        fontWeight={500}>{getBpm(item?.bpm_max, item?.bpm_min)}</Typography>
                    <Typography
                        sx={{ textAlign: isUserTypePolo ? "center" : 'right', flex: 1, order: isUserTypePolo ? -2 : 0 }}
                        variant='caption'
                        fontWeight={500}>{item?.percentage + ' %'}</Typography>
                </Box>
                <LinearProgress sx={{
                    backgroundColor: 'transparent',
                    border: '0.5px solid gray',
                    overflow: 'hidden',
                    height: 12,
                    borderRadius: 1,
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: item.color
                    }
                }} variant='determinate' value={item?.percentage}></LinearProgress>
            </Box>
        )) : <></>}
    </div>
}

export default memo(HrActivityZone)